import React, { useEffect, useState } from "react";

import { Crumbs } from "molecules/Breadcrumbs";
import { SectionBorder } from "molecules/SectionBorder";
import { TitleHeading } from "molecules/TitleHeading";
import { TextVideoSection } from "container/TextVideoSection/index2";
import PeopleSlider from "./PeopleSlider";
import { SmallHadding } from "molecules/SmallHeadding";
import { InnerBanner } from "container/InnerpageBanner/index2";
import { useSelector } from "react-redux";
import { fetchAboutOurPeople } from "../../api";
import { useSearchParams } from "react-router-dom";

export const OurPeople = () => {
  const [aboutOurPeopleData, setAboutOurPeopleData] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const { data: ourServiceData, loading: loadingourService, error: errorourService } = useSelector((state) => state.ourPeopleData);
  const { data, loading, error } = useSelector((state) => state.dashboard);


  // Fetch about our people data
  useEffect(() => {
    const loadAboutOurPeople = async () => {
      try {
        const data = await fetchAboutOurPeople();
        if (data && data.length > 0) {
          setAboutOurPeopleData(data[0]);
        }
      } catch (error) {
        console.error("Error fetching about our people:", error);
      }
    };
    loadAboutOurPeople();
  }, []);

  useEffect(() => {
    const raw = searchParams.get("personId");
    const pid = raw != null ? String(raw).trim() : "";
    if (!pid || !Array.isArray(ourServiceData) || ourServiceData.length === 0) {
      return undefined;
    }
    const t = window.setTimeout(() => {
      const el = document.getElementById(`person-${pid}`);
      if (el?.scrollIntoView) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      const next = new URLSearchParams(searchParams);
      next.delete("personId");
      setSearchParams(next, { replace: true });
    }, 450);
    return () => window.clearTimeout(t);
  }, [searchParams, setSearchParams, ourServiceData]);
  const sliderdata = [
    {
      title: "Lorem Ipsum is simply dummy text of the printing and...",
      description:
        "Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience” Quantum imb...",
      // image: "media/home_slider/blog-1-400x248 1.png",
      video: [
        "media/home_slider/blog-1-400x248 1.png",
        "https://www.apollo.com/008dda46-7301-4387-bc6b-03343b468d4b",
      ],
    },
    {
      title: "Lorem Ipsum is simply dummy text of the printing and...",
      description:
        "Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience” Quantum imb...",
      image: "media/home_slider/blog-1-400x248 1 (1).png",
    },
    {
      title: "Lorem Ipsum is simply dummy text of the printing and...",
      description:
        "Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience” Quantum imb...",
      image: "media/home_slider/blog-1-400x248 1.png",
    },
    {
      title: "Lorem Ipsum is simply dummy text of the printing and...",
      description:
        "Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience” Quantum imb...",
      image: "media/home_slider/blog-1-400x248 1 (2).png",
    },
  ];
  return (
    <div className="backgroundThm mobileContainer">
      <div className="container pl-0">
      <Crumbs />
      </div>
      <div className="container  pl-0 pr-0 ">
      <InnerBanner
        bannertext={aboutOurPeopleData?.banner_text || "Lorem Ipsum is simply dummy text of the printing and typesetting in..."}
        innertitle={aboutOurPeopleData?.page_name || "Our People"}
        image={
          aboutOurPeopleData?.banner_media_path ||
          data?.our_people_banner_image
        }
      />
      </div>
     
      <section className="section-padding " style={{padding:0}}>
        <div className="container pl-0 pr-0 py-0 ">
          <div className="grid -mr-2 ml-0 ">
            <div className="lg:col-4 md:col-3 sm:col-12  ml-0 pt-0 py-0 pl-0"  data-aos="fade-up">
              <TitleHeading title="Our Leaders" className="mt-0 p-0 mb-3" />
            
            </div>

            <div className="lg:col-12 md:col-12 sm:col-12 py-0  pl-0 pr-0" style={{paddingLeft:'0%'}}>
              <PeopleSlider 
              data={ourServiceData}
              />
            </div>
          </div>
        </div>
       
      </section>
      {/* <SectionBorder className="border-black-alpha-80" /> */}
      {/* <div className="container p-0"> */}
    <div className="container  pl-0 pr-0 py-0 pb-5" style={{marginTop:'0px',}}>
      {/* <div className="container py-0 pl-0 "> */}
      {/* <div className="pl-2"> */}
    <TextVideoSection />
    {/* </div> */}
    {/* </div> */}
    {/* </div> */}
    </div>
    </div>
  );
};
